export let RESELLER_WITHDRAWAL_STATUSES = /*#__PURE__*/function (RESELLER_WITHDRAWAL_STATUSES) {
  RESELLER_WITHDRAWAL_STATUSES["pending"] = "pending";
  RESELLER_WITHDRAWAL_STATUSES["approved"] = "approved";
  RESELLER_WITHDRAWAL_STATUSES["rejected"] = "rejected";
  return RESELLER_WITHDRAWAL_STATUSES;
}({});
export let RESELLER_PAYOUT_STATUSES = /*#__PURE__*/function (RESELLER_PAYOUT_STATUSES) {
  RESELLER_PAYOUT_STATUSES["CHECKING"] = "CHECKING";
  RESELLER_PAYOUT_STATUSES["SAVINGS"] = "SAVINGS";
  return RESELLER_PAYOUT_STATUSES;
}({});
export let RESELLER_APPLICATION_STATUSES = /*#__PURE__*/function (RESELLER_APPLICATION_STATUSES) {
  RESELLER_APPLICATION_STATUSES["pending"] = "pending";
  RESELLER_APPLICATION_STATUSES["approved"] = "approved";
  RESELLER_APPLICATION_STATUSES["rejected"] = "rejected";
  return RESELLER_APPLICATION_STATUSES;
}({});
export let RESELLER_APPLICATION_FIELDS = /*#__PURE__*/function (RESELLER_APPLICATION_FIELDS) {
  RESELLER_APPLICATION_FIELDS["_id"] = "_id";
  RESELLER_APPLICATION_FIELDS["email"] = "email";
  RESELLER_APPLICATION_FIELDS["phone"] = "phone";
  RESELLER_APPLICATION_FIELDS["firstName"] = "firstName";
  RESELLER_APPLICATION_FIELDS["lastName"] = "lastName";
  RESELLER_APPLICATION_FIELDS["companyName"] = "companyName";
  RESELLER_APPLICATION_FIELDS["industry"] = "industry";
  RESELLER_APPLICATION_FIELDS["certificateNumber"] = "certificateNumber";
  RESELLER_APPLICATION_FIELDS["yearsInBusiness"] = "yearsInBusiness";
  RESELLER_APPLICATION_FIELDS["companyRevenue"] = "companyRevenue";
  RESELLER_APPLICATION_FIELDS["status"] = "status";
  RESELLER_APPLICATION_FIELDS["publicId"] = "publicId";
  RESELLER_APPLICATION_FIELDS["createdAt"] = "createdAt";
  RESELLER_APPLICATION_FIELDS["updatedAt"] = "updatedAt";
  RESELLER_APPLICATION_FIELDS["referredBy"] = "referredBy";
  return RESELLER_APPLICATION_FIELDS;
}({});
export let RESELLER_APPLICATION_SORTING_FIELDS = /*#__PURE__*/function (RESELLER_APPLICATION_SORTING_FIELDS) {
  RESELLER_APPLICATION_SORTING_FIELDS["createdAt"] = "createdAt";
  return RESELLER_APPLICATION_SORTING_FIELDS;
}({});
export let RESELLER_WITHDRAWAL_FIELDS = /*#__PURE__*/function (RESELLER_WITHDRAWAL_FIELDS) {
  RESELLER_WITHDRAWAL_FIELDS["_id"] = "_id";
  RESELLER_WITHDRAWAL_FIELDS["requestedBy"] = "requestedBy";
  RESELLER_WITHDRAWAL_FIELDS["status"] = "status";
  RESELLER_WITHDRAWAL_FIELDS["resellerTransactionPublicId"] = "resellerTransactionPublicId";
  return RESELLER_WITHDRAWAL_FIELDS;
}({});
export let RESELLER_SORTING_FIELDS = /*#__PURE__*/function (RESELLER_SORTING_FIELDS) {
  RESELLER_SORTING_FIELDS["overallRevenue"] = "overallRevenue";
  RESELLER_SORTING_FIELDS["applicationApprovalDate"] = "applicationApprovalDate";
  RESELLER_SORTING_FIELDS["orderCount"] = "orderCount";
  RESELLER_SORTING_FIELDS["customerCount"] = "customerCount";
  return RESELLER_SORTING_FIELDS;
}({});
export let RESELLERS_FILTER_STATUSES = /*#__PURE__*/function (RESELLERS_FILTER_STATUSES) {
  RESELLERS_FILTER_STATUSES["ALL"] = "all";
  RESELLERS_FILTER_STATUSES["REFERRER"] = "referrer";
  RESELLERS_FILTER_STATUSES["REFEREE"] = "referee";
  return RESELLERS_FILTER_STATUSES;
}({});